module.exports = __webpack_public_path__ + "img/buffet.a055a29f.jpeg";